import CampaignListPage from "@/views/campaign/CampaignListPage.vue";
import CampaignDtlPage from "@/views/campaign/CampaignDtlPage.vue";

const campaignRoutes = [
    {
        path: "/campaign",
        children: [
          {
            path: "",
            name: "CampaignListPage",
            component: CampaignListPage
          },
          {
            path: "campaign-dtl/:campaignSeq",
            name: "CampaignDtlPage",
            components: {
              default: CampaignDtlPage,
            },
            props: {
              default: true,
            },
          },
        ],
      },
]

export default campaignRoutes;